import DashboardLegal from "./Dashboard.vue"
export default DashboardLegal